import React from "react";
import ProjectCard from "./ProjectCard";
import "./Projects.css";

function Projects() {
  // Define the handleLiveLinkClick function
  const handleLiveLinkClick = (e, projectTitle) => {
    e.preventDefault();
    if (projectTitle === "Digital Resume Builder") {
      alert("Live website not available for this project, but I will update soon.");
    }
  };

  return (
    <div className="projects">
      <h2>My Projects</h2>
      <div className="project-list">

        {/* Image Resizer - NEW */}
        <ProjectCard
          title="Image Resizer"
          points={[
            "Fast, high-quality image resizing & compression tool",
            "Resize by MB/KB or custom dimensions with batch support",
            "100% client-side, secure, with light/dark theme"
          ]}
          githubLink="https://github.com/kunjkhanpara/Image-Resizer"
          liveLink="https://kunjkhanpara.github.io/Image-Resizer/"
        />

        <ProjectCard
          title="Instagram Unfollower Tracker"
          points={[
            "Analyze Instagram followers and following data",
            "Identify non-followers and pending requests",
            "Developed for efficient data processing"
          ]}
          githubLink="https://github.com/kunjkhanpara/Instagram_Unfollower_Tracker"
          liveLink="https://kunjkhanpara.github.io/Instagram_Unfollower_Tracker/"
        />

        <ProjectCard
          title="Digital Resume Builder"
          points={[
            "Create resumes with 3 customizable templates",
            "Real-time preview for seamless editing",
            "Download resumes as PDF instantly"
          ]}
          githubLink="https://github.com/kunjkhanpara/Digital-Resume-Builder"
          liveLink="#"
          onClickLiveLink={(e) => handleLiveLinkClick(e, "Digital Resume Builder")}
        />

        <ProjectCard
          title="Tic-Tac-Toe-Game"
          points={[
            "Classic tic-tac-toe game for two players",
            "Highlights the winner or declares a tie",
            "Built with HTML, CSS, and JavaScript."
          ]}
          githubLink="https://github.com/kunjkhanpara/Tic-Tac-Toe-Game"
          liveLink="https://kunjkhanpara.github.io/Tic-Tac-Toe-Game/"
        />

        <ProjectCard
          title="Weather-Application-Using-API-Key"
          points={[
            "Weather app providing real-time weather updates",
            "Displays temperature, humidity, and wind speed for cities",
            "Built with HTML, CSS, JavaScript, and WeatherStack API"
          ]}
          githubLink="https://github.com/kunjkhanpara/Weather-Application-Using-API-Key"
          liveLink="https://kunjkhanpara.github.io/Weather-Application-Using-API-Key/"
        />

        <ProjectCard
          title="Shopping-Cart"
          points={[
            "Add, edit, or remove items in the cart",
            "Supports custom items with dynamic pricing",
            "View total price instantly"
          ]}
          githubLink="https://github.com/kunjkhanpara/Shopping-Cart"
          liveLink="https://kunjkhanpara.github.io/Shopping-Cart/"
        />

      </div>
    </div>
  );
}

export default Projects;
